// extracted by mini-css-extract-plugin
export default {"manufacturer-grp-report-container":"manufacturerGroup_manufacturer-grp-report-container__Bmvtl"};